import React from 'react';

const CreateVC = () => {
  return (
    <div className="genericPageContainer grey">
      <div className="genericTitleBar">Create VizCode</div>
      <div className="create-vizcode-container genericPageWrap grey">
      
        <div className="genericSettingsColumn gsp-left">
          <div className="genericSettingsPanel gsp-left">
            <div className="genericSettingsForm">
              <h5 className="gsp-title">Wearer</h5>
              <div className="gsp-input">
                <p className="gsp-label">Full Name</p>
                <input className="gsp-textinp"/>
              </div>
              <div className="gsp-input gsp-input-last">
                <p className="gsp-label">Date of Birth</p>
                <input className="gsp-textinp" placeholder="MM/DD/YYYY" maxLength="10"/>
              </div>
            </div>
            <div className="genericSettingsForm">
              <h5 className="gsp-title gsp-title-sub">Contact</h5>
              <div className="gsp-input">
                <p className="gsp-label">Full Name</p>
                <input className="gsp-textinp"/>
              </div>
              <div className="gsp-input">
                <p className="gsp-label">Email Address</p>
                <input className="gsp-textinp" placeholder="MM/DD/YYYY" maxLength="10"/>
              </div>
              <div className="gsp-input">
                <p className="gsp-label">Mobile Number</p>
                <input className="gsp-textinp" placeholder="Optional" maxLength="10"/>
              </div>
            </div>
          </div>
        </div>
        
        <div className="genericSettingsColumn gsp-right">
          <div className="genericSettingsPanel">
            <h5 className="gsp-title">Medical</h5>
            <div className="gsp-input">
              <p className="gsp-label">Mobile Number</p>
              <input className="gsp-textinp" placeholder="Optional" maxLength="10"/>
            </div>
            <div className="gsp-input">
              <p className="gsp-label">Mobile Number</p>
              <input className="gsp-textinp" placeholder="Optional" maxLength="10"/>
            </div>
            <div className="gsp-input">
              <p className="gsp-label">Mobile Number</p>
              <input className="gsp-textinp" placeholder="Optional" maxLength="10"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateVC;



// WEBPACK FOOTER //
// ./src/components/CreateVizCode/CreateVC.js